import { useState } from "react";
import { CircularProgress, styled } from "@mui/material";
import SettingsModal from "../Modal/settingsCustomModal";
import { ReactComponent as RouteIcon } from "../../../../svg/adminRoleIcon.svg";
import ViewContent from "./ViewContent";
import EditRoutePage from "./EditRoutePage";
import DeleteRoutePage from "./DeleteRoutePage";
import apiCall from "../../../../utils/apiCall";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import ViewRoutePage from "./ViewRoutePage";

interface Routes {
  Id: number;
  RouteType: string;
  Messages: string;
  IsActive: boolean;
  RouteId: number;
}

interface RouteData {
  Data: Routes[];
}

// interface RoutesResponse {
//     data: RouteData;
// };

interface ButtonProp {
  handleClick: () => void;
}

const RoutePageEditor = () => {
  const [openRouteModal, setOpenRouteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [routeInfo, setRouteInfo] = useState<Routes>({
    Id: 0,
    IsActive: false,
    RouteType: "Hello",
    Messages: "Hello World",
    RouteId: 0,
  });

  const handleOpenRouteModal = () => setOpenRouteModal(true);
  const handleCloseRouteModal = () => setOpenRouteModal(false);

  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => setOpenEditModal(false);

  const handleOpenDeleteModal = () => setOpenDeleteModal(true);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);

  const GetAllRoutePageEditor = async (): Promise<RouteData> => {
    return (await apiCall().get("/SetUp/GetAllRoutePageEditor")).data;
  };

  const { data, isLoading, error, isError } = useQuery(
    ["get-all-routes-page-editor"],
    GetAllRoutePageEditor,
    {
      retry: 0,
      keepPreviousData: true,
      enabled: true,
    }
  );

  const routeData = data?.Data;
  const GetAllRoutePageEditorError = error as AxiosError;
  const GetAllRoutePageEditorErrorMessage = GetAllRoutePageEditorError?.message;

  const handleEdit = () => {
    handleCloseRouteModal();
    handleOpenEditModal();
  };

  const handleDelete = () => {
    handleCloseRouteModal();
    handleOpenDeleteModal();
  };

  const handleOpen = (route: Routes) => {
    setRouteInfo({ ...route });
    handleOpenRouteModal();
  };

  return (
    <StyledContainer>
      {isLoading ? (
        <CircularProgress
          sx={{
            display: "block",
            marginInline: "auto",
            marginBlock: "2rem",
            fontSize: "1rem",
          }}
        />
      ) : isError ? (
        <StyledError>{GetAllRoutePageEditorErrorMessage}</StyledError>
      ) : (
        <>
          <TotalWrapper>
            <span>Total</span>
            <TotalNumberStyle>{routeData?.length}</TotalNumberStyle>
          </TotalWrapper>
          {routeData && routeData?.length > 0
            ? routeData?.map((data: Routes, index: number) => (
                <RoleWrapper onClick={() => handleOpen(data)} key={index}>
                  <div>
                    <RoleIconWrapper>
                      <RouteIcon />
                    </RoleIconWrapper>
                    <RoleText>{data?.RouteType}</RoleText>
                    {data?.IsActive === true ? (
                      <Active>Active</Active>
                    ) : (
                      <Disabled>Disabled</Disabled>
                    )}
                    {/* <DateWrapper>{data.Messages}</DateWrapper> */}
                  </div>
                </RoleWrapper>
              ))
            : ""}
        </>
      )}

      <SettingsModal
        open={openRouteModal}
        cancel={handleCloseRouteModal}
        maxWidth={"712px"}
        header={routeInfo?.RouteType}
        content={<ViewRoutePage {...routeInfo} />}
        card={
          <ViewContent handleEdit={handleEdit} handleDelete={handleDelete} />
        }
      />

      <SettingsModal
        open={openEditModal}
        cancel={handleCloseEditModal}
        maxWidth="90vw"
        header={routeInfo.RouteType}
        showrightIcon={false}
        content={<EditRoutePage {...routeInfo} />}
      />

      <SettingsModal
        open={openDeleteModal}
        cancel={handleCloseDeleteModal}
        maxWidth="536px"
        header="Delete Route"
        showrightIcon={false}
        content={
          <DeleteRoutePage
            handleClose={handleCloseDeleteModal}
            id={routeInfo.Id}
            routeName={routeInfo.RouteType}
          />
        }
      />
    </StyledContainer>
  );
};

export default RoutePageEditor;

const StyledContainer = styled("div")`
  margin-block: 3.8rem;
  margin-inline: 3.5rem;
`;
const TotalWrapper = styled("div")`
  color: #4e5a62;
  font-weight: 500;
`;
const TotalNumberStyle = styled("span")`
  background-color: #f1f3f4;
  border-radius: 0.2rem;
  margin-inline-start: 0.4rem;
  padding-inline: 0.2rem;
`;
const RoleWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  border: 0.1rem solid #e1e1e1;
  margin-block: 0.6rem;
  padding-inline: 1.2rem;
  padding-block: 1.2rem;
  border-radius: 0.5rem;
  width: 100%;
  text-align: left;
  background-color: transparent;
`;

const RoleIconWrapper = styled("span")`
  background-color: #fff4de;
  border-radius: 0.1rem;
  padding-inline: 0.4rem;
`;

const RoleText = styled("span")`
  font-weight: 600;
  font-size: 16px;
  margin-inline: 0.8rem;
`;

const Active = styled("span")`
  font-size: 14px;
  font-weight: 500;
  background-color: #e0faee;
  border-radius: 0.4rem;
  padding-inline: 0.5rem;
  color: #11643c;
`;

const DateWrapper = styled("div")`
  margin-block-start: 0.8rem;
  font-size: 14px;
`;

const ArrowIconWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Disabled = styled("span")`
  font-size: 1rem;
  font-weight: 500;
  background-color: #fae0e0;
  border-radius: 0.4rem;
  padding-inline: 0.5rem;
  color: #dd5151;
`;

const StyledError = styled("p")`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;
